var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('v-card',{staticClass:"event-object-wrapper"},[_c('v-toolbar',{attrs:{"color":"default","dark":"","dense":""}},[_c('v-toolbar-title',[_c('small',[_vm._v(" Upravujete poznámku na mapě ")])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }